import { render, staticRenderFns } from "./Lgx235744141521190912.vue?vue&type=template&id=c27be98e&"
import script from "./Lgx235744141521190912.vue?vue&type=script&lang=js&"
export * from "./Lgx235744141521190912.vue?vue&type=script&lang=js&"
import style0 from "./Lgx235744141521190912.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports